import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
export const CircleCheckPink = ({ classObject }) => {
    return React.createElement("img", { className: css(styles.container, classObject), src: "/assets/images/icons/circle_check_pink.svg" });
};
const styles = StyleSheet.create({
    container: {},
});
